import { render, staticRenderFns } from "./ApprovalTableSlot.vue?vue&type=template&id=10201e4a"
import script from "./ApprovalTableSlot.vue?vue&type=script&lang=js"
export * from "./ApprovalTableSlot.vue?vue&type=script&lang=js"
import style0 from "./ApprovalTableSlot.vue?vue&type=style&index=0&id=10201e4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports